import UAHelper from 'fk-cp-shared/utils/UAHelper';
import AndroidNativeCaller from 'fk-cp-shared/components/android/NativeCaller';
import IOSNativeCaller from 'fk-cp-shared/components/ios/NativeCaller';
import MapiConfigProvider from 'fk-cp-shared/MapiConfigProvider';
// import flags from '@utils/Flags';
import { isCibEnabled, getCibPartnerContext } from 'fk-cp-common-components/utils/commerceInABox';

let instance;
let mapiUrl, secureMapiUrl, secureWebUrl, webUrl;
let baseConfig;

class BaseAjax {
	constructor() {
		if (!instance) {
			instance = this;
		}
		try {
			if (__CAN_DEBUG__) {
				if (
					UAHelper._isAndroid() &&
					AndroidNativeCaller.bridgeAvailable() &&
					typeof window.Android.getSecureMapiUrl === 'function'
				) {
					mapiUrl = window.Android.getSecureMapiUrl();
				} else if (UAHelper._isIOS() && IOSNativeCaller.bridgeAvailable()) {
					secureMapiUrl = IOSNativeCaller.run('getSecureMapiUrl');
				}
				if (secureMapiUrl) {
					secureMapiUrl.then(
						data => {
							if (data) {
								data = JSON.parse(data);
								if (data.url) {
									mapiUrl = data.url;
								}
							}
						},
						error => {
							console.log('IOS secure mapi url Bridge Call Error', error);
						}
					);
				}
				if (secureWebUrl) {
					secureWebUrl.then(
						data => {
							if (data) {
								data = JSON.parse(data);
								if (data.url) {
									webUrl = data.url;
								}
							}
						},
						error => {
							console.log('IOS secure web url Bridge Call Error', error);
						}
					);
				}
			}
		} catch (error) {
			console.log('Error Occured to get Mapi and Web secure url', error);
		}
		return instance;
	}

	getConfig() {
		baseConfig = { ...MapiConfigProvider.config };
		if (isCibEnabled()) {
			const client = window.cibAndroidInterface.getClientName();
			if (!baseConfig.headers) {
				baseConfig.headers = {};
			}
			baseConfig.headers['X-PARTNER-CONTEXT'] = getCibPartnerContext(client);
		}
		if (__CAN_DEBUG__) {
			const { ProxyProvider, PreferenceProvider } = require('rv-debugger');
			if (UAHelper._isMsite()) {
				let hostString = ProxyProvider.MAPI({
					url: PreferenceProvider.getItem('mapi_host', ''),
					verbose: true
				}).replace(/https?:\/\//g, '');
				if (hostString) {
					baseConfig = Object.assign(baseConfig, { host: hostString });
				}
			} else if (mapiUrl) {
				let url = ProxyProvider.MAPI({
					url: mapiUrl.replace(/https?:\/\//g, ''),
					verbose: true
				});
				if (url === 'mobileapi.flipkart.net' || url === 'www.flipkart.com' || url === 'm.flipkart.com') {
					return baseConfig;
				}
				baseConfig = Object.assign(baseConfig, {
					hostname: url.replace(/https?:\/\//g, ''),
					overrideMapiEndpoint: true
				});
			}
		}
		baseConfig.headers = { ...baseConfig.headers, "X-Flipkart-Client": 'self-serve'} 
		// if(__CAN_DEBUG__)
		// 	baseConfig.headers['X-PERF-TEST'] = true
		return baseConfig;
	}
}

export default new BaseAjax();
